/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcRouteV1RoutingRuleState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_ROUTE_V1_ROUTING_RULE_STATE_ENTITY_NAME = 'exc.route.v1.RoutingRule';
export const excRouteV1RoutingRuleStateEntity = new schema.Entity<ExcRouteV1RoutingRuleState>(EXC_ROUTE_V1_ROUTING_RULE_STATE_ENTITY_NAME, {}, { idAttribute: 'ruleId' });

